import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useContext, useMemo } from "react"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import { AppContext } from "../Home/context"
import TagItem from "./TagItem"
import ArticleTypeAdd from "./ArticleTypeAdd"
import AuthorAdd from "./AuthorAdd"
import { ParameterTab, Tag } from "Types/app"
import { IVariable } from "Types/table"
import { useInputChange } from "Hooks/basic"
import { useOldTable as useTable } from "Hooks/table"
import { tableInitialVariables } from "Methods/table"
import { InitialModal } from "Methods/modal"
import { checkUserPrivilege } from "Methods/privilege"
import { generateMutation, generateQuery } from "Methods/query"
import cnchar from "cnchar"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        width: "100%",
        overflow: "hidden",
    },
    text: {
        marginLeft: theme.spacing(4),
    },
    info: {
        padding: "10px 20px",
        color: "#666666",
        fontSize: 14,
    },
}))
const initVariables = {
    ...tableInitialVariables,
    limit: 1000,
}
interface ComponentProps {
    tab: ParameterTab,
    index: number,
    privilegeMap: any,
}

const TabPanel = (props: ComponentProps) => {
    const { tab, privilegeMap } = props
    const { value, where } = tab
    const classes = useStyles()
    const { handleChangeModal } = useContext(AppContext)
    const privilege = checkUserPrivilege(privilegeMap, value)
    const addVariables: IVariable[] = useMemo(() => {
        if (value === "article_type") {
            return [
                { name: "name", type: "String" },
                { name: "type_name", type: "String" },
                { name: "color_code", type: "String" },
                { name: "hidden", type: "Boolean" },
            ]
        } else if (value === "author") {
            return [
                { name: "name", type: "String" },
                { name: "uid", type: "String" },
                { name: "hidden", type: "Boolean" },
            ]
        } else {
            return [
                { name: "name", type: "String" },
                { name: "hidden", type: "Boolean" },
            ]
        }
    }, [value])
    const { data, onRowAdd, onRowUpdate, onRowDelete } = useTable({
        tableName: value,
        initVariables: {
            ...initVariables,
            where: where ? where : initVariables.where
        },
        getQuery: generateQuery(value),
        addMutation: generateMutation("insert", value, addVariables),
        updateMutation: generateMutation("update", value, [
            { name: "name", type: "String" },
            { name: "hidden", type: "Boolean" },
            { name: "id", type: "Int" },
        ]),
        delMutation: generateMutation("delete", value, [
            { name: "id", type: "Int" },
        ]),
        field: ["id", "name", "hidden"],
    })
    const { text: name, handleChange, clearText } = useInputChange("")
    const handleDelete = (tag: Tag) => {
        handleChangeModal({
            show: true,
            type: "warning",
            title: `确定删除 ${tag.name}？`,
            showCancel: true,
            onConfirm: async () => {
                // await onRowUpdate({
                //     ...tag,
                //     hidden: true,
                // })
                await onRowDelete({
                    ...tag
                })
                handleChangeModal({
                    show: true,
                    type: "success",
                    title: "已删除！",
                    timeout: 800,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            },
            onCancel: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    const sortFn = value === "author" || value === "operation_person" ? (a: any, b: any) => {
        if (cnchar.isCnChar(a.name) && cnchar.isCnChar(b.name)) {
            // 汉字和汉字比
            return cnchar.compareSpell(a.name, b.name) === "more" ? 1 : -1
        } else if (cnchar.isCnChar(a.name) || cnchar.isCnChar(b.name)) {
            // 汉字和英文比
            return cnchar.isCnChar(a.name) ? 1 : -1
        } else {
            // 英文和英文比
            return a.name.localeCompare(b.name)
        }
    } : () => { }
    return (
        <Fragment>
            <Grid container className={classes.root} justify="flex-start">
                {data.sort(sortFn).map((tag: Tag) => (
                    <Grid key={tag.id} item>
                        <TagItem value={value} tag={tag} onDelete={handleDelete} privilege={privilege} />
                    </Grid>
                ))}
                {privilege.insert && (
                    <Grid item>
                        {value === "article_type" && <ArticleTypeAdd onRowAdd={onRowAdd} />}
                        {value === "author" && <AuthorAdd onRowAdd={onRowAdd} />}
                        {value === "operation_person" && (
                            <TextField
                                className={classes.text}
                                label="添加"
                                value={name}
                                onChange={handleChange}
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        onRowAdd({ name, hidden: false })
                                        clearText()
                                    }
                                }} />
                        )}
                    </Grid>
                )}
            </Grid>
            {value === "author" && <em className={classes.info}>备注：括号里为已关联用户昵称</em>}
        </Fragment>
    )
}

export default TabPanel
